import script from "./TermAndCondition.vue?vue&type=script&setup=true&lang=js"
export * from "./TermAndCondition.vue?vue&type=script&setup=true&lang=js"

import "./TermAndCondition.vue?vue&type=style&index=0&id=629440a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629440a8"]])

export default __exports__